import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { s as smallStyles, n as normalStyles, c as transparentloadingStyles, l as loadingStyles, g as globalStyles, t as transparentStyles, e as colorMixin, a as primaryStyles, b as defaultStyles } from '../Button.styles-Ck-xVxAl.js';
import { L as LoadingIcon } from '../LoadingIcon-DySNdZRD.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { j as externalLink } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { I as Icon } from '../../Icon/Icon-AcXbY_t4.js';

const StyledExternalIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-zz2mge-0"
})(["font-size:0.85em;"]);
const ExternalLinkIcon = () => /*#__PURE__*/React__default.createElement(StyledExternalIcon, {
  type: externalLink
});
const globalLinkStyles = /*#__PURE__*/css(["", " text-decoration:none;"], globalStyles);
const defaultLinkButtonStyles = /*#__PURE__*/css(["", " ", ""], defaultStyles, ({
  $disabled
}) => $disabled && css([":hover{border-color:", ";background-color:", ";}:active{background-color:", ";}cursor:not-allowed;outline:none;opacity:1;border-color:", ";", " background-color:", ";pointer-events:all;"], ({
  theme
}) => theme.border.color.medium.unavailable, ({
  theme
}) => theme.button.backgroundColor.secondary.unavailable, ({
  theme
}) => theme.button.backgroundColor.secondary.unavailable, ({
  theme
}) => theme.border.color.medium.unavailable, colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.secondary.unavailable));
const transparentLinkButtonStyles = /*#__PURE__*/css(["", " ", ""], transparentStyles, ({
  $disabled
}) => $disabled && css([":hover{border-color:transparent;background-color:", ";}:active{background-color:", ";}cursor:not-allowed;outline:none;opacity:1;border-color:transparent;", " background-color:", ";pointer-events:all;"], ({
  theme
}) => theme.button.backgroundColor.transparent.unavailable, ({
  theme
}) => theme.button.backgroundColor.transparent.unavailable, colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.transparent.unavailable));
const primaryLinkButtonStyles = /*#__PURE__*/css(["", " ", ""], primaryStyles, ({
  $disabled
}) => $disabled && css([":hover{border-color:transparent;background-color:", ";}:active{background-color:", ";}cursor:not-allowed;outline:none;opacity:1;", " background-color:", ";border-color:transparent;pointer-events:all;"], ({
  theme
}) => theme.button.backgroundColor.primary.unavailable, ({
  theme
}) => theme.button.backgroundColor.primary.unavailable, colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.primary.unavailable));
const StyledLinkButton = /*#__PURE__*/styled('a').withConfig({
  componentId: "sc-storm-ui-40027066__sc-zz2mge-1"
})(["", ";&,:visited,:active,:link{", ";", ";", ";&&:focus-visible{", "}margin:0;}"], globalLinkStyles, ({
  $small
}) => $small ? smallStyles : normalStyles, ({
  $primary,
  $transparent
}) => {
  if ($transparent) {
    return transparentLinkButtonStyles;
  }
  if ($primary) {
    return primaryLinkButtonStyles;
  }
  return defaultLinkButtonStyles;
}, ({
  $loading,
  $transparent
}) => {
  if ($loading) {
    if ($transparent) {
      return transparentloadingStyles;
    }
    return loadingStyles;
  }
  return undefined;
}, focusOutline);
const LinkButton = ({
  href,
  linkRef,
  disabled,
  small,
  variant = 'default',
  loading,
  loadingLabel,
  children,
  taktId,
  taktValue,
  onClick,
  external,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('button')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(StyledLinkButton, _extends({}, getDataTaktAttributes(), external && {
  target: '_blank',
  rel: 'noopener noreferrer'
}, rest, {
  ref: linkRef
}, !disabled && {
  href
}, {
  tabIndex: disabled ? -1 : 0,
  $disabled: disabled,
  $primary: variant === 'primary',
  $small: small,
  $transparent: variant === 'transparent',
  $loading: loading
}, loading && {
  'aria-live': 'assertive'
}, (loading || disabled) && {
  'aria-disabled': true
}, {
  onClick: loading ? undefined : onClick
}), loading && /*#__PURE__*/React__default.createElement(LoadingIcon, null), loading && loadingLabel ? loadingLabel : children, external && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\xA0", /*#__PURE__*/React__default.createElement(ExternalLinkIcon, null))));

export { LinkButton as L };
//# sourceMappingURL=LinkButton-BfLKDh0v.js.map
